import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import utility from "../../helpers/utility";
import localStorageFunc from "../../helpers/localStorageFunc";
import headers from "../../config/headers";

export default {
  namespaced: true,
  state: {
    sgOneClickWidgetData: [],
    sgCreateStatus: "",
    sgPollingStatus: "",
    sgStatusData: {},
    isSgBottomSheetOpen: false,
  },
  getters: {},
  mutations: {
    updateSgOneClickData(state, payload) {
      const { sgDetails } = payload;
      state.sgOneClickWidgetData = sgDetails;
    },
    updateSgCreateStatus(state, payload) {
      state.sgCreateStatus = payload;
    },
    updateSgStatusData(state, payload) {
      state.sgStatusData = payload;
    },
    updateSgPollingStatus(state, payload) {
      state.sgPollingStatus = payload;
    },
    updateIsSgBottomSheetOpen(state, payload) {
      state.isSgBottomSheetOpen = payload;
    },
  },
  actions: {
    getSgWidgetData({ commit, dispatch }, payload) {
      const { apiUrl } = payload;
      const defaultHeaders = Headers();
      ApiCalls.GET_SG_ONECLICK_DATA({
        headers: {
          ...defaultHeaders,
          Mobile: localStorageFunc.getMobileNumber(),
        },
        payload: {
          apiUrl,
        },
      })
        .then((res) => {
          if (res?.data) {
            commit("updateSgOneClickData", res?.data);
          } else {
            console.log("no data received");
          }
        })
        .catch((error) => {
          console.log("error in fetching status response: ", error);
        });
    },
    sgCreate({ commit, dispatch, state, rootState }, payload) {
      const defaultHeaders = Headers();
      const pollingInterval = rootState.Config?.appConfig?.config?.sgOneClickConfig?.pollingInterval || 3000;
      ApiCalls.SG_CREATE({
        headers: {
          ...defaultHeaders,
        },
        payload,
      })
        .then((res) => {
          if (res?.data && (res?.data?.status !== "FAILURE" && res?.data?.status !== "FAILED")) {
            commit("updateSgCreateStatus", "SUCCESS");
            // start polling - hit sgPolling api in every 3 seconds
            // Start polling every 3 seconds, total 5 times (15 seconds)
            const { eventId } = res?.data || {};
            const { wiorderId } = payload || {};
            let pollCount = 0;
            const maxPolls = 5;
            const interval = setInterval(() => {
              pollCount++;
              if (state.isSgBottomSheetOpen) {
                dispatch("sgPolling", {
                  eventId,
                  orderId: wiorderId,
                });
              }
              if (pollCount >= maxPolls || !state.isSgBottomSheetOpen) {
                clearInterval(interval);
              }
            }, pollingInterval);
          } else {
            commit("updateSgCreateStatus", "FAILURE");
            commit("updateSgPollingStatus", "F");
          }
        })
        .catch((error) => {
          console.log("error in creating SG: ", error);
          commit("updateSgCreateStatus", "FAILURE");
        });
    },
    sgPolling({ commit, rootState, rootGetters }, payload) {
      const defaultHeaders = Headers();
      ApiCalls.SG_ONECLICK_STATUS({
        headers: {
          ...defaultHeaders,
          Mobile: localStorageFunc.getMobileNumber(),
        },
        payload,
      })
        .then((res) => {
          if (res?.data) {
            commit("updateSgStatusData", res?.data);
            const { state = ''} = res?.data || {};
            commit("updateSgPollingStatus", state);
          } else {
            commit("updateSgPollingStatus", 'F');
          }
        })
        .catch((error) => {
          console.log("error in fetching status response: ", error);
          commit("updateSgPollingStatus", "F");
        });
    },
  },
};

/* 
All States:-
SUCCESS - show success screen
FAILURE - show failure screen
POLLING - show pending screen and start polling
INITIATED - show initiated screen
REJECTED - show rejected screen
*/
